import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrOnSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_on_select"}/>
}
